import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React from "react";
import { PTButton, PTCircular } from ".";
import PTTranslate from "./PTTranslate";

export const PTDialog = (props) => {
  const {
    title,
    description,
    open,
    actions = [],
    onConfirm,
    onCancel,
    onClose,
    dialogStyle,
    dialogData = {},
    descriptionStyle,
    titleStyle,
    cancelBtn = "cancel",
    ...otherProps
  } = props;
  const [loading, setLoading] = React.useState(false);
  const startLoading = () => setLoading(true);
  const stopLoading = () => setLoading(false);
  return (
    <Dialog
      open={open}
      onClose={!loading ? onClose : undefined}
      sx={{ ...(dialogStyle || {}) }}
      {...otherProps}
    >
      {title && (
        <DialogTitle sx={{ textAlign: "center", ...(titleStyle || {}) }}>
          <PTTranslate tk={title} />
        </DialogTitle>
      )}
      <DialogContent sx={{ ...(descriptionStyle || {}) }}>
        <PTCircular isCircul={loading}>
          {typeof description === "string" ? (
            <p>
              <PTTranslate tk={description} />
            </p>
          ) : typeof description === "function" ? (
            React.createElement(description, { ...dialogData })
          ) : React.isValidElement(description) ? (
            React.cloneElement(description, { ...dialogData })
          ) : (
            <p>{description}</p>
          )}
        </PTCircular>
      </DialogContent>
      <DialogActions sx={{ gap: "5px" }}>
        {actions.map((action) => {
          return (
            <PTButton
              {...action}
              key={action.key}
              onClick={action.onClick}
              color={action.color}
              title={action.title}
            />
          );
        })}
        {onCancel && (
          <PTButton
            title={"cancel"}
            onClick={() => {
              onCancel();
              onClose();
            }}
            disabled={loading}
            color="secondary"
          />
        )}
        {onConfirm && (
          <PTButton
            title={"confirm"}
            onClick={() => {
              onConfirm(startLoading, stopLoading);
            }}
            disabled={loading}
            variant="contained"
            color="primary"
          />
        )}
      </DialogActions>
    </Dialog>
  );
};

export default PTDialog;
